export function resolveStoryBucketBaseUrl(
  bucketEndpoint: string | null | undefined,
  bucketName: string | null | undefined
): string | null {
  const normalizedEndpoint = bucketEndpoint?.trim().replace(/\/+$/, '');
  if (!normalizedEndpoint) {
    return null;
  }

  const normalizedBucketName = bucketName?.trim();
  if (!normalizedBucketName) {
    return normalizedEndpoint;
  }

  const normalizedBucketPath = `/${normalizedBucketName}`.toLowerCase();
  if (normalizedEndpoint.toLowerCase().endsWith(normalizedBucketPath)) {
    return normalizedEndpoint;
  }

  try {
    const endpointUrl = new URL(normalizedEndpoint);
    const normalizedHost = endpointUrl.hostname.toLowerCase();
    const bucketHostPrefix = `${normalizedBucketName.toLowerCase()}.`;

    if (
      normalizedHost === normalizedBucketName.toLowerCase() ||
      normalizedHost.startsWith(bucketHostPrefix)
    ) {
      return normalizedEndpoint;
    }
  } catch {
    // Fall through to path-style composition for non-URL inputs.
  }

  return `${normalizedEndpoint}/${normalizedBucketName}`;
}
